import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiUser, FiMessageSquare } = FiIcons;

const testimonials = [
  {
    id: 1,
    content: "Το CodeVaro μεταμόρφωσε την επιχείρησή μας. Η νέα ιστοσελίδα και το e-shop αύξησαν τις πωλήσεις μας κατά 200% μέσα σε 6 μήνες. Η τεχνική υποστήριξη είναι άμεση και επαγγελματική.",
    author: "Γιώργος Παπαδόπουλος",
    position: "Ιδιοκτήτης, ElectroShop",
    rating: 5,
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80"
  },
  {
    id: 2,
    content: "Η ομάδα του CodeVaro μας βοήθησε να αυτοματοποιήσουμε πολλές λειτουργίες στο ξενοδοχείο μας. Οι κρατήσεις αυξήθηκαν και οι πελάτες μας είναι ενθουσιασμένοι με το νέο σύστημα check-in.",
    author: "Μαρία Κωνσταντίνου",
    position: "Διευθύντρια, Blue Bay Hotel",
    rating: 5,
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80"
  },
  {
    id: 3,
    content: "Εξαιρετική συνεργασία! Το digital marketing πακέτο που μας πρότειναν έφερε άμεσα αποτελέσματα. Συστήνω ανεπιφύλακτα τις υπηρεσίες τους σε κάθε επιχείρηση που θέλει να αναπτυχθεί.",
    author: "Νίκος Αντωνίου",
    position: "CEO, FreshFood",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80"
  },
  {
    id: 4,
    content: "Οι εφαρμογές που ανέπτυξαν για το ιατρείο μας έχουν κάνει τη διαχείριση των ραντεβού πολύ πιο εύκολη. Οι ασθενείς μας μπορούν πλέον να κλείνουν ραντεβού online και να λαμβάνουν υπενθυμίσεις αυτόματα.",
    author: "Δρ. Ελένη Παπαδάκη",
    position: "Παιδίατρος",
    rating: 5,
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80"
  },
  {
    id: 5,
    content: "Ευχαριστούμε το CodeVaro για την άψογη συνεργασία. Η εγκατάσταση του νέου POS συστήματος και η διασύνδεση με την ΑΑΔΕ έγινε γρήγορα και χωρίς προβλήματα. Πάντα διαθέσιμοι για υποστήριξη.",
    author: "Αντώνης Δημητρίου",
    position: "Ιδιοκτήτης, Café Central",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80"
  },
  {
    id: 6,
    content: "Η δημιουργία του e-learning portal για το φροντιστήριό μας άλλαξε τον τρόπο που παρέχουμε εκπαίδευση. Οι μαθητές μας έχουν πρόσβαση σε εκπαιδευτικό υλικό 24/7 και οι γονείς μπορούν να παρακολουθούν την πρόοδό τους.",
    author: "Στέλλα Αλεξίου",
    position: "Διευθύντρια Σπουδών, ExcelEdu",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80"
  }
];

function TestimonialCard({ testimonial, index }) {
  return (
    <motion.div
      className="bg-white rounded-xl shadow-lg p-6 md:p-8"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      viewport={{ once: true }}
      whileHover={{ y: -5 }}
    >
      {/* Rating */}
      <div className="flex mb-4">
        {[...Array(testimonial.rating)].map((_, i) => (
          <SafeIcon key={i} icon={FiStar} className="w-5 h-5 text-yellow-500 fill-current" />
        ))}
      </div>
      
      {/* Content */}
      <div className="mb-6">
        <div className="relative">
          <SafeIcon icon={FiMessageSquare} className="w-8 h-8 text-blue-100 absolute -top-4 -left-2 transform -rotate-6" />
          <p className="text-gray-700 relative z-10">"{testimonial.content}"</p>
        </div>
      </div>
      
      {/* Author */}
      <div className="flex items-center">
        {testimonial.image ? (
          <img 
            src={testimonial.image} 
            alt={testimonial.author}
            className="w-12 h-12 rounded-full object-cover mr-4"
          />
        ) : (
          <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mr-4">
            <SafeIcon icon={FiUser} className="w-6 h-6 text-blue-600" />
          </div>
        )}
        <div>
          <h4 className="font-bold text-gray-900">{testimonial.author}</h4>
          <p className="text-sm text-gray-500">{testimonial.position}</p>
        </div>
      </div>
    </motion.div>
  );
}

function TestimonialsSection() {
  return (
    <section id="testimonials" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Τι λένε οι πελάτες μας
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Μάθετε πώς έχουμε βοηθήσει επιχειρήσεις όπως τη δική σας να αναπτυχθούν και να επιτύχουν τους στόχους τους.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={testimonial.id} testimonial={testimonial} index={index} />
          ))}
        </div>

        {/* Call to Action */}
        <motion.div
          className="mt-16 text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl shadow-lg p-8 md:p-12 text-white">
            <h3 className="text-2xl font-bold mb-4">
              Γίνετε κι εσείς μέρος της επιτυχίας
            </h3>
            <p className="text-lg text-blue-100 mb-8">
              Περισσότερες από 500 επιχειρήσεις έχουν ήδη εμπιστευθεί τις υπηρεσίες μας. Ελάτε σε επαφή μαζί μας για να συζητήσουμε πώς μπορούμε να βοηθήσουμε και τη δική σας επιχείρηση.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <motion.button
                className="bg-white text-blue-600 px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors font-semibold"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Κλείστε Δωρεάν Ραντεβού
              </motion.button>
              <motion.button
                className="border-2 border-white text-white px-8 py-3 rounded-lg hover:bg-white hover:text-blue-600 transition-colors font-semibold"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Δείτε Περισσότερες Μαρτυρίες
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default TestimonialsSection;